"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardEntity = void 0;
require("reflect-metadata");
const class_transformer_1 = require("class-transformer");
class BoardEntity {
    constructor(partial) {
        Object.assign(this, partial);
    }
    static createFromBoard(board) {
        if (!board) {
            return;
        }
        return {
            id: board.id,
            communityCards: board.communityCards,
            mainPot: board.pot.amount,
            bigBlindAmount: board.blinds ? board.blinds.big : undefined,
            smallBlindAmount: board.blinds ? board.blinds.small : undefined,
            state: board.internalState(),
        };
    }
}
__decorate([
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], BoardEntity.prototype, "id", void 0);
__decorate([
    class_transformer_1.Expose(),
    __metadata("design:type", Array)
], BoardEntity.prototype, "communityCards", void 0);
__decorate([
    class_transformer_1.Expose(),
    __metadata("design:type", Number)
], BoardEntity.prototype, "mainPot", void 0);
__decorate([
    class_transformer_1.Expose(),
    __metadata("design:type", Number)
], BoardEntity.prototype, "bigBlindAmount", void 0);
__decorate([
    class_transformer_1.Expose(),
    __metadata("design:type", Number)
], BoardEntity.prototype, "smallBlindAmount", void 0);
__decorate([
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], BoardEntity.prototype, "state", void 0);
exports.BoardEntity = BoardEntity;
//# sourceMappingURL=BoardEntity.js.map